import { stringifyHelper } from './stringifyHelper';

interface IErrorJsonData {
  readonly name?: string;
  readonly message?: string;
  readonly stack?: string;
}

export const getErrorJsonData = (rawError: unknown): IErrorJsonData => {
  if (rawError instanceof Error) {
    const { name, message, stack } = rawError;
    return {
      name,
      message,
      stack
    }; // If raw error is an error instance, extract name, message and stack directly as JSON.stringify will return {} for Error instance
  } else {
    return {
      name: 'Unknown error',
      message: stringifyHelper(rawError)
    };
  }
};
